import { Heading } from 'blaze-ui/Heading/Heading'
import { ChannelOption } from 'components/Wizards/CampaignWizard/Types'
import { DesignChannel } from './DesignChannel'
import Styles from './DesignChannels.module.scss'

interface Props {
  channels: ChannelOption[]
}

export const DesignChannels = ({ channels }: Props) => {
  return (
    <div className={Styles.designChannels}>
      <Heading level={4}>Pick designs for visual content you selected</Heading>
      <div className={Styles.grid}>
        {channels.map((channel) => {
          const { channel_type, width, height } = channel
          const key = width && height ? `${channel_type}-${width}-${height}` : channel_type
          return <DesignChannel key={key} channel={channel} />
        })}
      </div>
    </div>
  )
}
